module.exports = __webpack_public_path__ + "img/kommune-2023.79ee5737.svg";